<nav
  mat-tab-nav-bar
  class="container tabs-container"
>
  <a
    mat-tab-link
    *ngFor="let link of navLinks; let i = index;"
    [routerLink]="basePath + link.path"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
  >
    {{ 'pages.about_us.title' + (i) | translate }}
  </a>
</nav>

<router-outlet></router-outlet>



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.html